// extracted by mini-css-extract-plugin
export default {"custom-rules-container":"SplitRules_custom-rules-container__A2Bxl","add-rule-button":"SplitRules_add-rule-button__SmJVf"};